<div id="wrapper">
  <div class="vertical-align-wrap">
    <div class="vertical-align-middle auth-main">
      <div class="auth-box">
        <div class="top text-white font-weight-bold">
          <img src="../assets/images/logo/ridereg_logo-white.png" alt="RideReg" class="img-responsive logo">

        </div>
        <div class="card" style="min-height: 300px;">
          <div class="header">
            <p class="lead">Agents Registration</p>
          </div>
          <div class="body" >
            <form class="form-auth-small"  #agentSignupForm="ngForm" (ngSubmit)="signupAgent()">
              <div class="step-1 step-">
                <div class="form-group">
                  <label for="email" class="control-label">Email</label>
                  <input type="email" class="form-control" autocomplete="" placeholder="Enter Email"
                         #email="ngModel" minlength="4" [pattern]="EMAIL_VALIDATION"
                         id="email"
                         [(ngModel)]="agentSignUp.email" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger" *ngIf="email.errors && (email.dirty || email.touched)">
                  <span class="validation-message" [hidden]="!email.hasError('pattern')">
                    Invalid Email Address<br>
                  </span>
                    <span class="validation-message" [hidden]="!email.hasError('required')">
                    Email Address is required</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="password" class="control-label">Password</label>
                  <input type="password" class="form-control" placeholder="Enter Password"
                         #password="ngModel" minlength="4" id="password" maxlength="79"
                         [(ngModel)]="agentSignUp.password" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger"  *ngIf="password.errors && (password.dirty || password.touched)">
                  <span class="validation-message" [hidden]="!password.hasError('minlength')">
                 Invalid password<br></span>
                    <span class="validation-message" [hidden]="!password.hasError('required')">
                 Password is required</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="confirm_password" class="control-label">Confirm Password</label>
                  <input type="password" class="form-control" placeholder="Confirm Password"
                         #confirm_password="ngModel" minlength="4" id="confirm_password" maxlength="79"
                         [(ngModel)]="agentSignUp.password_confirmation" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger"  *ngIf="confirm_password.errors && (confirm_password.dirty || confirm_password.touched)">
                  <span class="validation-message" [hidden]="!confirm_password.hasError('minlength')">
                 Invalid password<br></span>
                    <span class="validation-message" [hidden]="!confirm_password.hasError('required')">
                 Enter Password again</span>
                  </div>
                </div>

                <div class="mb-2 mt-1">
                  <!--<button type="button"  class="btn btn-danger float-lg-left">Previous</button>-->
                  <button role="button" class="btn btn-info float-lg-right" [disabled]="email.errors || password.errors || confirm_password.errors"
                        (click)="movePage('f', 2, $event)">Proceed</button>
                </div>
              </div>
              <div class="step-2 d-none step-">
                <div class="form-group">
                  <label for="first_name" class="control-label">First Name</label>
                  <input type="text" class="form-control" placeholder="First Name"
                         #first_name="ngModel"
                         id="first_name"
                         [(ngModel)]="agentSignUp.first_name" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger" *ngIf="first_name.errors && (first_name.dirty || first_name.touched)">
                  <span class="validation-message" [hidden]="!first_name.hasError('required')">
                    First name is required</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="last_name" class="control-label">Last Name</label>
                  <input type="text" class="form-control" placeholder="Last Name"
                         #last_name="ngModel"
                         id="last_name"
                         [(ngModel)]="agentSignUp.last_name" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger" *ngIf="last_name.errors && (last_name.dirty || last_name.touched)">
                  <span class="validation-message" [hidden]="!last_name.hasError('required')">
                    Last name is required</span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="phone_number" class="control-label">Phone</label>
                  <input type="text" class="form-control" placeholder="Phone Number"
                         #phone_number="ngModel"
                         id="phone_number"
                         [(ngModel)]="agentSignUp.phone_no" [ngModelOptions]="{standalone: true}" required>
                  <div class="text-danger" *ngIf="phone_number.errors && (phone_number.dirty || phone_number.touched)">
                  <span class="validation-message" [hidden]="!phone_number.hasError('required')">
                    Phone number is required</span>
                  </div>
                </div>
                <div class="mb-2 mt-1">
                  <span role="button"  class="btn btn-danger float-lg-left" (click)="movePage('b', 1, $event)">Previous</span>
                  <button role="button" class="btn btn-info float-lg-right"
                        [disabled]="first_name.errors || last_name.errors || phone_number.errors"
                        (click)="movePage('f', 3, $event)">Next</button>
                </div>
              </div>


              <div class="step-3 d-none step-">


                <div class="form-group">
                  <label for="superagent_code" class="control-label">Super Agent Code(Optional)</label>
                  <input type="text" class="form-control" placeholder="Super Agent Code"
                         #superagent_code="ngModel"
                         id="superagent_code"
                         [(ngModel)]="agentSignUp.super_agent_code" [ngModelOptions]="{standalone: true}">
                 <!-- <div class="text-danger" *ngIf="superagent_code.errors && (superagent_code.dirty || superagent_code.touched)">
                  <span class="validation-message" [hidden]="!superagent_code.hasError('minlength')">
                    Invalid Agent Code<br></span>
                    <span class="validation-message" [hidden]="!superagent_code.hasError('required')">
                    Super Agent Code is required</span>
                  </div>-->
                </div>

                <div class="form-group">
                  <label for="selectState" class="control-label">Select State</label>
                  <ng-select [items]="allStates" class="ng-select-form" required id="selectState"
                             [notFoundText]="'No data available'"
                             [placeholder]="'Select State'"
                             bindLabel="name"
                             bindValue="id" (change)="filterLGA($event)"
                             [multiple]="false" >
                  </ng-select>
                </div>

                <div class="form-group">
                  <label for="selectLGA" class="control-label">Select LGA</label>
                  <ng-select [items]="allLGA" class="ng-select-form" #lga="ngModel" required id="selectLGA"
                             [notFoundText]="'No data available'"
                             [placeholder]="'Select LGA'"
                             bindLabel="name"
                             bindValue="id"
                             [multiple]="false"
                             [(ngModel)]="agentSignUp.lga_id" [ngModelOptions]="{standalone: true}" >
                  </ng-select>

                  <div class="text-danger" *ngIf="lga.errors && (lga.dirty || lga.touched)">
                  <span class="validation-message" [hidden]="!lga.hasError('required')">
                    LGA is required</span>
                  </div>
                </div>
                <div class="mb-2 mt-1">
                  <button type="button" *ngIf="!loaders.login"  class="btn btn-danger float-lg-left" (click)="movePage('b', 2, $event)">Previous</button>
                  <!--|| superagent_code.errors-->
                  <button type="submit" class="btn btn-success float-lg-right"
                          *ngIf="!loaders.login" [disabled]="password.errors || email.errors || first_name.errors">Submit</button>
                  <span *ngIf="loaders.login" class="btn btn-success float-lg-right">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span >

                </div>
              </div>
<!--

              <button type="submit" class="btn btn-primary btn-lg btn-block"
                      *ngIf="!loaders.login" [disabled]="password.errors || email.errors">REGISTER</button>
              <span *ngIf="loaders.login" class="btn btn-primary btn-lg btn-block">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span >
-->



              <div class="bottom" style="padding-top: 60px;">
                <hr>
                <span class="helper-text m-b-10"><i class="fa fa-lock"></i> &nbsp;<a [routerLink]="['/login']">Already registered? Login</a></span>
                <!--                <span>Don't have an account? <a href="page-register.html">Register</a></span>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
